import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { Box, Button, TextField, Grid, Typography } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import Divider from "@mui/material/Divider";
import { Link, useNavigate, useParams } from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';

// how to craete search coulmn in raactjs?
function Customermaster() {

  //usestate declaration
  const navigate = useNavigate();
  const [customerInput, setcustomer] = useState({
    name: "",
    gstno: "",
    pcode: "",
    acode: "",
    maddress: "",
    email: "",
    address: "",
    cname: "",
    cnamecontact: "",
    error_list: [],
  });

  //input handling function
  const handleInput = (e) => {
    e.persist();
    setcustomer({ ...customerInput, [e.target.name]: e.target.value });
  };

  //colour palette
  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });


  //data submit function
  const submitCustomer = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);

    const data = {
      name: customerInput.name,
      gstno: customerInput.gstno,
      // col1:customerInput.col1,
      pcode: customerInput.pcode,
      acode: customerInput.acode,
      maddress: customerInput.maddress,
      email: customerInput.email,
      address: customerInput.address,
      cname: customerInput.cname,
      cnamecontact: customerInput.cnamecontact,
      user_id:userId,
      // gs:customerInput.gs,
    }

    //api calling
    axios.post(`api/store-customer`, data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        document.getElementById("CATEGORY_FORM").reset();
        navigate("/certificates/customermaster");
      } else if (res.data.status === 400) {
        setcustomer({ ...customerInput, error_list: res.data.errors });
      }
    });
  };

  //api for dropdown
  const [categorylist, setCategorylist] = useState([]);
  useEffect(() => {
    axios.get(`api/view-customer`).then((res) => {
      if (res.status === 200) {
        setCategorylist(res.data.customer);
      }
    });
  }, []);

  //error handling
  var display_errors = [];
  if (customerInput.error_list) {
    display_errors = [
      customerInput.error_list.name,
      customerInput.error_list.gstno,
      // customerInput.error_list.col1,
      customerInput.error_list.pcode,
      customerInput.error_list.email,
      // customerInput.error_list.gs,
      customerInput.error_list.address,
      customerInput.error_list.maddress,
      customerInput.error_list.acode,
      customerInput.error_list.cname,
      customerInput.error_list.cnamecontact,
    ];
  }

  //dropdown value mapping
  const values = categorylist.map((item) => {
    return <option value={categorylist.acode}>{item.pcode}</option>;
  });
  // const [age, setAge] = useState('')

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };


  //main function
  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <Grid container spacing={70}>
            <Grid item xs={8}>
              <h4>Add Customer</h4>
            </Grid>
            <Grid item xs={4}>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/customermaster"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
        </div>
        <form onSubmit={submitCustomer} id="CATEGORY_FORM">
          <Box paddingTop={1} borderRadius={1} paddingLeft={5} paddingRight={5}>
            <Grid container spacing={5}>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="name"
                  onChange={handleInput}
                  value={customerInput.name}
                  id="outlined-basic"
                  margin="normal"
                  label="Party Name"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.name}
                </span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="gstno"
                  onChange={handleInput}
                  value={customerInput.gstno}
                  id="outlined-basic"
                  margin="normal"
                  label="GST NO"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.gstno}
                </span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="pcode"
                  onChange={handleInput}
                  value={customerInput.pcode}
                  id="outlined-basic"
                  margin="normal"
                  label="Party Code"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.pcode}
                </span>
              </Grid>
            </Grid>
            <Grid item xs={4}>
            <TextField fullWidth name="gstno" onChange={handleInput} value={customerInput.gstno} id="outlined-basic" margin="normal" label="GST NO" variant="outlined" />
            <span style={{color: "red"}} >{customerInput.error_list.gstno}</span>
            </Grid>
            <Grid item xs={4}>
            <TextField fullWidth name="pcode" onChange={handleInput} value={customerInput.pcode} id="outlined-basic" margin="normal"  variant="outlined" />
            <span style={{color: "red"}} >{customerInput.error_list.pcode}</span>
            </Grid>
            
             <Grid container spacing={5}>
            <Grid item xs={4}>
            {/* <TextField fullWidth name="acode" onChange={handleInput} value={customerInput.acode} id="outlined-basic" margin="normal" label="Associate Code" variant="outlined" />
            <span style={{color: "red"}} >{customerInput.error_list.acode}</span> */}
                {/* <Box sx={{ minWidth: 120 }}>
       <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Associate Code</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Age"
          onChange={handleChange}
        >
         {values}
        </Select>
       </FormControl>
       </Box> */}

                <Box marginTop={2} padding={1} borderRadius={1}>
                  <select
                    name="acode"
                    class="form-select"
                    aria-label="Default select example"
                    onChange={handleInput}
                    value={customerInput.acode}
                  >
                    <option selected>Associate Code</option>
                    {values}
                  </select>
                  <span style={{ color: "red" }}>
                    {customerInput.error_list.acode}
                  </span>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="maddress"
                  onChange={handleInput}
                  value={customerInput.maddress}
                  id="outlined-basic"
                  margin="normal"
                  label="Mini Address"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.maddress}
                </span>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="email"
                  onChange={handleInput}
                  value={customerInput.email}
                  id="outlined-basic"
                  margin="normal"
                  label="Email"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.email}
                </span>
              </Grid>
            </Grid>

            <TextField
              fullWidth
              name="address"
              onChange={handleInput}
              value={customerInput.address}
              id="outlined-basic"
              margin="normal"
              label="Address"
              variant="outlined"
            />
            <span style={{ color: "red" }}>
              {customerInput.error_list.address}
            </span>

            <Grid container spacing={5}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="cname"
                  onChange={handleInput}
                  value={customerInput.cname}
                  id="outlined-basic"
                  margin="normal"
                  label="Party Contact Person"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.cname}
                </span>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  name="cnamecontact"
                  onChange={handleInput}
                  value={customerInput.cnamecontact}
                  id="outlined-basic"
                  margin="normal"
                  label="Contact Number"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>
                  {customerInput.error_list.cnamecontact}
                </span>
              </Grid>
            </Grid>
            <ThemeProvider theme={theme}>
              <Box
                marginTop={5}
                display="flex"
                padding={3}
                borderRadius={5}
                alignItems="center"
                justifyContent={"center"}
              >
                <Button
                  style={{
                    maxWidth: "200px",
                    maxHeight: "100px",
                    minWidth: "50px",
                    minHeight: "30px",
                  }}
                  color="apple"
                  type="submit"
                  variant="contained"
                >
                  Submit
                </Button>
              </Box>
            </ThemeProvider>
          </Box>
        </form>
      </div>
    </div>
  );
}

export default Customermaster;
